import { LexiconsState } from './models';
import { LEXICON_DEFAULT_PER_PAGE } from './limits';

export const defaultState: LexiconsState = {
  isFetching: false,
  isMutating: false,
  lexicons: {},
  // 25, per the prototype (not the repo-wide DEFAULT_PER_PAGE of 10).
  limit: LEXICON_DEFAULT_PER_PAGE,
  offset: 0,
  hasMore: false,
  deletedCount: 0,
  deletedCountExact: true,
  showDeleted: false,
  isDrawerOpen: false,
  // Starts false rather than true: an environment with no registry is discovered by
  // a failed resolve, and defaulting to "not configured" would flash the feature
  // off on every cold load before the first fetch settles.
  isNotConfigured: false,
};

/**
 * Newer-module naming convention: `vtn-<app>-<layer>-<name>`. Older shared
 * modules use bare names (`app`, `player`), but new reducers follow this form.
 */
export const namespace = 'vtn-redact-state-lexicons';

export interface LexiconsStore {
  [namespace]: LexiconsState;
}
